import { forwardRef } from 'react'

interface SvgProps {
  className?: string
}

const X = forwardRef<SVGSVGElement, SvgProps>(({ className }, ref) => {
  return (
    <svg
      ref={ref}
      className={className}
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="29.0607"
        y1="1.06066"
        x2="2.06066"
        y2="28.0607"
        stroke="currentColor"
        strokeWidth="3"
      />
      <line
        x1="28.9315"
        y1="28.0607"
        x2="1.93153"
        y2="1.06066"
        stroke="currentColor"
        strokeWidth="3"
      />
    </svg>
  )
})

export default X

X.displayName = 'X'
